import React from "react";
import {ProcessedTourCatalog, ProcessedTourOperator, ProcessedTripItinerary} from "../contentfulModel";

interface IntroductionTabProps {
    tourPackage: ProcessedTripItinerary;
    tourOperator: ProcessedTourOperator;
    tourCatalog: ProcessedTourCatalog;
}

export const IntroductionTab: React.FC<IntroductionTabProps> = ({ tourPackage,tourOperator,tourCatalog }) => {
    const introImageUrl = encodeURI(decodeURI(tourPackage.introductionImage?.file ||
        tourPackage.mainImage?.file || ''));

    const isMobile = window.innerWidth < 768;
    return (
        <div
            className="w-full h-full pt-16 relative flex"
            style={{
                backgroundImage: `url(${introImageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            {/* Gradient overlay for text readability */}
            <div
                className="absolute inset-0 z-0"
                style={{
                    background: !isMobile ? 'linear-gradient( 90deg, rgb(247, 246, 242) 0%, rgba(247, 246, 242, 0.9) 20%, rgba(247, 246, 242, 0.7) 30%, rgba(247, 246, 242, 0.4) 40%, rgba(247, 246, 242, 0.1) 50%,rgba(247, 246, 242, 0.05) 55%, rgba(247, 246, 242, 0) 100% )':
                        'linear-gradient(to top, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0.8) 80%, rgba(255,255,255,0) 100%)'
                }}
            ></div>

            {/* Content container */}
            <div className="flex w-full h-full relative z-10">
                {/* Left section - 40% width */}
                <div className="w-full md:w-3/5 lg:w-2/5 p-6 px-6 md:px-8 text-left flex flex-col justify-between overflow-y-auto overscroll-contain pb-20 md:pb-6 md:px-[70px]">
                    <div>
                    <div className="text-md uppercase md:text-xl md:font-medium mb-1 md:pt-6">{tourPackage.category}</div>
                    <h2 className="text-xl md:text-2xl font-semibold md:font-black mb-1">
                        {tourPackage.name}
                    </h2>
                    {tourPackage.subtitle && (
                        <p className="text-lg font-normal md:font-semibold mb-4">{tourPackage.subtitle}</p>
                    )}

                    <div className="prose max-w-none">
                        {tourPackage.description && (
                            <p className="text-sm md:text-md mb-6 text leading-6.5">{tourPackage.description}</p>
                        )}

                    </div>
                    </div>
                    { tourCatalog.partnerLogo ?
                        <div>
                            <img src={tourCatalog.partnerLogo.file} alt="Partner Logo" className="w-30 md:w-40 md:mt-10  md:block"/>
                        </div> : null }
                </div>

                {/* Right section - 60% width (empty, just for spacing) */}
                <div className="hidden md:flex lg:w-3/5"></div>
                <img crossOrigin="anonymous" src={tourOperator.logoContrast.file} className="w-40 absolute bottom-4 right-4"
                     alt={tourOperator.name}/>
            </div>
        </div>
    );
};
